import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Page, PageHero } from "src/components/common";
import { UserManagementTabs } from "./Tabs/UserManagementTabs";

type UserManagementPageProps = {
	location?: any;
};

export const UserManagementPage: FC<UserManagementPageProps> = ({
	location,
	children,
}) => {
	return (
		<Page>
			<PageHero>
				<h1 className="mb-0">User Management</h1>
			</PageHero>
			<UserManagementTabs className="mb-4" location={location} />
			{children}
		</Page>
	);
};
